import { Separator } from '@monksflow/monks-ui';

export function FormSubsection(props: React.PropsWithChildren) {
  return (
    <>
      {/* Not decorative: the rule is what marks the boundary between two groups
          of fields, and Tessra's default would drop that role. */}
      <Separator decorative={false} />
      <h3 className="text-sm font-medium text-foreground">{props.children}</h3>
    </>
  );
}
